import _ from 'lodash';
import { getRemotePathFromBreadcrumb } from '../store/StoreUtil';
import HashMap from '../protocol/HashMap';
import {
  MoveAssetsQuery,
  MoveAssetsMessage,
  MoveAssetsResponse,
  RepoItem,
  FacetedItemInfo,
  CategoryChangeQuery,
  CategoryChangeMsg,
  FilesStatData,
  FileFilters,
  PathFuidsList,
  GetAssetsPathFuidsResponse
} from '../autogenerated/ZoomBridge';
import t from '../i18n/I18n';
import ThumbnailUtil from './ThumbnailUtil';
import { isNonAliveAsset } from './SelectedItemUtil';

const debug = require('../debug/debug')('wc:util:RepoItemUtil');

export async function runMoveAssetsQuery(sources: RepoItem[], target: RepoItem): MoveAssetsResponse {
  try {
    debug('[moveAssets()] args: ', { sources, target });

    if (isNonAliveAsset(target)) {
      throw new Error(t('NON_ALIVE_TARGET', { TARGET: target.getName() }));
    }

    if (
      _.includes(
        sources.map((s) => s.getFuid()),
        target.getFuid()
      )
    ) {
      throw new Error('Invalid move');
    }

    const sourcePath = getRemotePathFromBreadcrumb();
    const targetPath = target.getRemotePath();
    const fuid2pathMap = new HashMap();

    sources.forEach((asset) => {
      //const path = `${sourcePath}/${asset.getName()}`;
      fuid2pathMap.put(asset.getFuid(), asset.getRemotePath());
    });

    const query = new MoveAssetsQuery();
    const message = new MoveAssetsMessage()
      .setDestPath(targetPath)
      .setFuid2PathMap(fuid2pathMap)
      .setLogMsg(`Moving assets from ${sourcePath} to ${targetPath}`);

    query.message = message;
    debug('[moveAssets()] running query: ', query);
    const res: MoveAssetsResponse = await query.run();
    if (!res.isSuccess()) {
      throw new Error(t('ERROR_MOVING_ASSETS'));
    }

    debug('[moveAssets()] result: ', res);
    return res;
  } catch (err) {
    debug('[moveAssets()] error: ', err);
    throw err;
  }
}

export async function runCategoryChangeQuery(
  categoryId: string,
  selected: boolean,
  facetedItemInfo: FacetedItemInfo,
  parentNode: ?FacetedItemInfo
): FilesStatData {
  try {
    debug('[runCategoryChangeQuery()] args: ', { categoryId, selected, facetedItemInfo, parentNode });
    const query = new CategoryChangeQuery();
    const msg = new CategoryChangeMsg();
    msg.setCategoryId(categoryId);
    let type2ItemMap = new HashMap();
    type2ItemMap.put('actualnode', facetedItemInfo);
    if (parentNode) {
      type2ItemMap.put('parentnode', parentNode);
    }
    msg.setTypeToFacetedItemMap(type2ItemMap);
    msg.setSelected(selected);
    query.message = msg;

    debug('[runCategoryChangeQuery()] running query: ', query);
    const res: FilesStatData = await query.run();
    debug('[runCategoryChangeQuery()] response: ', res);

    return res;
  } catch (err) {
    debug('[runCategoryChangeQuery()] error: ', err);
    throw err;
  }
}

export function isFileFiltersEmpty(fileFilters: FileFilters) {
  if (!fileFilters) {
    return true;
  }

  const types = fileFilters.getFileTypes() || [];
  const ext = fileFilters.getExtension() || [];
  const map: HashMap = fileFilters.getFilter2ValueMap() || new HashMap();

  return types.length === 0 && ext.length === 0 && map.size() === 0;
}

export function removeRepoFromArray(assets: Array<RepoItem>, deletedAssets: Array<RepoItem>): Array<RepoItem> {
  return assets.filter(
    (asset: RepoItem) => !deletedAssets.some((deletedAsset: RepoItem) => deletedAsset.getFuid() === asset.getFuid())
  );
}

export async function getAssetPathFuids(fuid, isFetchRepoItem = false) {
  try {
    const fuids = _.isArray(fuid) ? fuid : [fuid];
    const assetPathResp: GetAssetsPathFuidsResponse = await ThumbnailUtil.getAssetPathFuids(fuids, isFetchRepoItem);

    const fuid2PathFuids: Map<number, PathFuidsList> = assetPathResp.getFuid2PathFuids();
    const pathFuidsList: PathFuidsList = fuid2PathFuids.get(fuid);
    debug('[getAssetPathFuids()] Path Fuids', pathFuidsList.getPathFuidsList());
    if (isFetchRepoItem) {
      return { repoItems: assetPathResp.getFuid2RepoItemList(), pathFuids: pathFuidsList.getPathFuidsList() };
    }
    return pathFuidsList.getPathFuidsList();
  } catch (error) {
    console.log(error);
    debug('[getAssetPathFuids()] error', error);
  }
}
